<template>

    <DataList :list="list"/>

</template>

<script>
import DataList from './data-list.vue'
import {getArticleList} from '@/api/article'

export default{
  components: {
    DataList
  },
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.getArticle()
  },
  methods: {
    getArticle () {
      getArticleList({size: 10, current: 1}).then(({success, data}) => {
        if (success) {
          this.list = data.records.map(item => ({title: item.title}))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

